function e(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
export {
  e as isRefObject
};
